import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { subscribe, unsubscribe } from './actions';
import { getPollingDateRange } from './selectors';

export const useDateSubscription = (panelId) => {
  const dispatch = useDispatch();
  const pollingDateRange = useSelector((state) => getPollingDateRange(state, panelId));

  useEffect(() => {
    dispatch(subscribe(panelId));

    return () => {
      dispatch(unsubscribe(panelId));
    };
  }, []);

  return pollingDateRange;
};

export default useDateSubscription;
